export default function ArrowDownSvg() {
    return (
        <svg   height="16" viewBox="0 0 104 59" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4L52 52L100 4" stroke="white" strokeWidth="9"/>
        </svg>
    )
}